export class CheckTokenReturn {
    isValid: boolean;
    ErrorMessage?: string;
    Url?: string;

    constructor(isValid:boolean, errorMessage ?:string, url?:string) {
        this.isValid = isValid;
        this.ErrorMessage = errorMessage;
        this.Url = url;
    }
}
